import React from 'react'
import HeadTitle from '../../components/text/head-title'
import CardTitle from '../../components/text/card-title'

const NoMatch = () => {
  return (
    <div>
      <HeadTitle text='noMatch.title' />
      <CardTitle text='noMatch.subtitle' />
    </div>
  )
}

export default NoMatch
